export default "__VITE_ASSET__BpFZaTYI__"